import Factory from './factory';
export default {
  init: function(node) {
    var $node = $(node);
    var transitionOptions = {
      $element: $node
    };

    return new Factory(transitionOptions);
  }
};
